import { forwardRef } from 'react';
import MuiSelect, { type SelectProps as MuiSelectProps } from '@mui/material/Select';

export type SelectProps<T = unknown> = MuiSelectProps<T>;

export const Select = forwardRef<HTMLDivElement, SelectProps>(
  ({ variant = 'outlined', fullWidth = true, ...rest }, ref) => (
    <MuiSelect ref={ref} variant={variant} fullWidth={fullWidth} {...rest} />
  )
);

Select.displayName = 'Select';
